import React from "react";
import { connect } from "react-redux";
import PostList from "../../components/posts";
import { ISortOption } from "../../components/sortDropdown";
import ISortByType from "../../../types/services/ISortByType";
import SortDropdown from "../../components/sortDropdown";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import { Row, Col, Button } from "reactstrap";
import isequal from "lodash.isequal";
import * as commonActions from "../../../utils/actions/common";
import { UserCharitiesProps, withUserCharities } from "../../composition";
import { isCurrentUserCollaborator } from "../../../utils/roleCheck";
import { withRouter } from "../../../utils/withRouter";

interface Props extends UserCharitiesProps {
  t: (str: string, vars?: any) => string;
  history: any;
  toggleViewsparkButton: (showViewsparkButton: boolean) => void;
}

interface State {
  sortBy: ISortByType;
  sortAsc: boolean;
  loadMore: boolean;
  postCount: number;
  showLoadMore: boolean;
}

const sortOptions: ISortOption[] = [
  { key: "SCHEDULE", show: "Published", colName: "scheduleTime" },
  { key: "CREATED", show: "Created", colName: "createdOn" },
  { key: "STATUS", show: "Status", colName: "status" },
];

class PostListContainer extends React.Component<Props, State> {
  state = {
    sortBy: { key: "SCHEDULE", show: "Published", colName: "scheduleTime" },
    sortAsc: false,
    loadMore: false,
    postCount: 15,
    showLoadMore: false,
  };

  sortChanged = (newOption: ISortOption) => {
    this.setState({
      sortBy: newOption,
    });
  };

  changeSortOrder = () => {
    this.setState({
      sortAsc: !this.state.sortAsc,
    });
  };

  createPost = () => {
    this.props.navigate("/viewsparks/new");
  };

  componentDidMount() {
    this.props.toggleViewsparkButton(false);
  }

  componentDidUpdate(prevProps: Readonly<Props>): void {
    if (!isequal(this.props.currentCharity, prevProps.currentCharity)) {
      this.setState({
        postCount: 15,
        showLoadMore: false,
      });
    }
  }

  componentWillUnmount() {
    this.props.toggleViewsparkButton(true);
  }

  updatePagination = () => {
    this.setState({
      postCount: this.state.postCount + 15,
    });
  };

  updateShowMore = (show: boolean) => {
    this.setState({
      showLoadMore: show,
    });
  };

  render() {
    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row className={s.marginBot}>
            <Col
              xs={10}
              md={6}
              key={"div-sort"}
              className={s.sortWrapper + " " + s.colMargin}
            >
              <div className={s.sortContainer}>
                <SortDropdown
                  options={sortOptions}
                  sortChanged={this.sortChanged}
                />
              </div>
              <div
                onClick={() => this.changeSortOrder()}
                className={s.arrowContainer}
              >
                {this.state.sortAsc && <div className={s.arrowUp} />}
                {!this.state.sortAsc && <div className={s.arrowDown} />}
              </div>
            </Col>
            {isCurrentUserCollaborator(this.props.currentCharity) && (
              <Col>
                <div className={s.actions}>
                  <div
                    className={s.viewsparkButton}
                    onClick={this.createPost}
                  />
                </div>
              </Col>
            )}
          </Row>

          <PostList
            sortBy={this.state.sortBy}
            sortAsc={this.state.sortAsc}
            postCount={this.state.postCount}
            updateShowMore={this.updateShowMore}
          />
          {this.state.showLoadMore && (
            <Row>
              <Button
                className={s.showMoreButton}
                onClick={this.updatePagination}
              >
                Show More
              </Button>
            </Row>
          )}
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { common } = state;
  return {
    showViewsparkButton: common.showViewsparkButton,
  };
};

const mapDispatchToProps = dispatch => ({
  toggleViewsparkButton: (showViewsparkButton: boolean) => {
    dispatch(commonActions.toggleViewsparkButton(showViewsparkButton));
  },
});

export default withUserCharities(
  connect<Props>(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(s)(withRouter(PostListContainer)))
);
